export function decodeUTF8(str: string): Uint8Array {
  const array = new Uint8Array(str.length);
  for (let index = 0; index < str.length; index++)
    array[index] = str.charCodeAt(index);
  return array;
}

export function encodeUTF8(array: Uint8Array): string {
  const chars = [];
  for (const character of array) {
    chars.push(String.fromCharCode(character));
  }
  return chars.join('');
}
